import React, { Component, Fragment } from 'react'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'
import Undo from 'material-ui/svg-icons/content/undo'
import CircularProgress from '@material-ui/core/CircularProgress'
import ActionDelete from 'material-ui/svg-icons/action/delete'
import IconButton from '@material-ui/core/IconButton'
import ImageEdit from 'material-ui/svg-icons/image/edit'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import { connect } from 'react-redux'
import { severitiesActions, confirmActions, messageActions } from '../../actions'
import TablePagination from '@material-ui/core/TablePagination'
import Typography from '@material-ui/core/Typography'
import { listTableStyle } from '../../styles'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import { reloadTable } from '../../utils/reloadTable'
import { findPermission, readOnly } from '../../utils/permissions'
import Visibility from '@material-ui/icons/Visibility'

class ListTable extends Component {
  state = {
    debounce: undefined
  }

  componentWillUpdate(newProps) {
    const { pagination, order, fetchSeverities, term } = newProps
    const { page, rowsPerPage: perPage } = pagination

    if (reloadTable(newProps, this.props)) {
      const debounce = setTimeout(() => {
        fetchSeverities({ page, perPage, order, term })
      }, 700)

      this.setState(state => {
        clearTimeout(state.debounce)
        return { debounce }
      })
    }

    return true
  }

  componentDidMount() {
    const { fetchSeverities } = this.props
    fetchSeverities()
  }

  handleChangePage = (event, page) => {
    const { pagination, handleChangePage, fetchSeverities, term } = this.props
    handleChangePage(page)
  }

  handleChangeRowsPerPage = event => {
    const perPage = event.target.value
    const { pagination, fetchSeverities, handleChangePerPage, term } = this.props
    handleChangePerPage(perPage)
  }

  handleSortTable = column => {
    const { order, changeOrderColumn, changeOrderDirection } = this.props
    if (column === ((order || {}).column || '')) {
      const direction = ((order || {}).direction || 1) === -1 ? 1 : -1
      changeOrderDirection(direction)
    } else {
      changeOrderColumn(column)
    }
  }

  renderActions = severity => {
    const { fetchSeverity, deleteSeverity, addConfirm, token, restoreSeverity } = this.props

    return (
      <Fragment>
        {readOnly('gravidades', token) &&
          !severity.deletedAt && (
            <IconButton
              onClick={() => {
                fetchSeverity(severity._id)
              }}
            >
              <Visibility nativeColor={'rgba(0, 0, 0, 0.87)'} />
            </IconButton>
          )}

        {!!severity.deletedAt && findPermission('gravidades', token).remover ? (
          <IconButton
            onClick={() => {
              const { changeMessage } = this.props

              addConfirm({
                confirmMessage: 'Confirma a restauração desta gravidade?',
                confirmFunction: () => {
                  restoreSeverity(severity._id)
                  changeMessage({ message: 'Restauração realizada com sucesso.' })
                }
              })
            }}
          >
            <Undo />
          </IconButton>
        ) : (
          <Fragment>
            {findPermission('gravidades', token).editar && (
              <IconButton
                onClick={() => {
                  fetchSeverity(severity._id)
                }}
              >
                <ImageEdit />
              </IconButton>
            )}

            {findPermission('gravidades', token).remover && (
              <IconButton
                onClick={() => {
                  const { changeMessage } = this.props

                  addConfirm({
                    confirmMessage: 'Confirma a exclusão desta gravidade?',
                    confirmFunction: () => {
                      deleteSeverity(severity._id)
                      changeMessage({ message: 'Exclusão realizada com sucesso.' })
                    }
                  })
                }}
              >
                <ActionDelete />
              </IconButton>
            )}
          </Fragment>
        )}
      </Fragment>
    )
  }

  render() {
    const { classes, severities = [], loadingSeverities, pagination, order = {} } = this.props
    return (
      <Paper className={classes.wrapperTable} elevation={4}>
        {!!loadingSeverities && (
          <div className={classes.wrapperLoader}>
            <CircularProgress />
          </div>
        )}
        <Table
          fixedHeader={true}
          wrapperStyle={{
            display: 'flex',
            flexDirection: 'column',
            maxHeight: 'var(--crud-table-height)'
          }}
          width={'990px'}
        >
          <TableHeader
            displaySelectAll={false}
            className={classes.tableHeader}
            adjustForCheckbox={false}
          >
            <TableRow>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'nome'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('nome')
                  }}
                >
                  Gravidade
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn style={{ width: '100px' }}>Ações</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            {(severities || []).length ? (
              (severities || []).map(severity => {
                return (
                  <TableRow key={severity._id}>
                    <TableRowColumn>{severity.nome}</TableRowColumn>
                    <TableRowColumn style={{ width: '100px' }}>
                      {this.renderActions(severity)}
                    </TableRowColumn>
                  </TableRow>
                )
              })
            ) : (
              <TableRow>
                <TableRowColumn>
                  <Typography noWrap style={{ textAlign: 'center', padding: '16px' }}>
                    {!!loadingSeverities ? 'Carregando...' : 'Não há registros.'}
                  </Typography>
                </TableRowColumn>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <div className={classes.paginationWrapper}>
          <div className={classes.page}>Página: {pagination.page + 1}</div>
          <TablePagination
            component="div"
            className={classes.pagination}
            labelRowsPerPage="Itens por página"
            labelDisplayedRows={({ from, to, count, page }) => {
              return `Exibindo de ${from} a ${to} de ${count}`
            }}
            rowsPerPageOptions={[25, 50, 100]}
            count={pagination.length}
            rowsPerPage={pagination.rowsPerPage}
            page={pagination.page}
            backIconButtonProps={{
              'aria-label': 'Página anterior'
            }}
            nextIconButtonProps={{
              'aria-label': 'Próxima página'
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </div>
      </Paper>
    )
  }
}

const mapStateToProps = state => {
  return {
    severity: state.severities.severity,
    severities: state.severities.severities,
    loadingSeverities: state.severities.loadingSeverities,
    token: state.auth.token,
    pagination: state.severities.severitiesPagination,
    order: state.severities.order,
    term: state.searchTable.term
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(severitiesActions.openModal())
    },
    closeModal: () => {
      dispatch(severitiesActions.closeModal())
    },
    fetchSeverity: id => {
      dispatch(severitiesActions.fetchSeverity(id))
    },
    fetchSeverities: options => {
      dispatch(severitiesActions.fetchSeverities(options))
    },
    deleteSeverity: id => {
      dispatch(severitiesActions.deleteSeverity(id))
    },
    addConfirm: ({ confirmMessage, confirmFunction }) => {
      dispatch(confirmActions.addFunction({ confirmMessage, confirmFunction }))
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    },
    handleChangePage: page => {
      dispatch(severitiesActions.handleChangePage(page))
    },
    handleChangePerPage: perPage => {
      dispatch(severitiesActions.handleChangePerPage(perPage))
    },
    restoreSeverity: id => {
      dispatch(severitiesActions.restoreSeverity(id))
    },
    changeOrderColumn: column => {
      dispatch(severitiesActions.changeOrderColumn(column))
    },
    changeOrderDirection: direction => {
      dispatch(severitiesActions.changeOrderDirection(direction))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(listTableStyle)(ListTable))



// WEBPACK FOOTER //
// ./src/containers/Severities/ListTable.js